export default __webpack_public_path__ + "static/media/DEShawa.10822683.webp";